
<v-content>
  <v-row wrap>
    <v-col cols="12">
      <h1 class="display-1 layout">
        {{ $t("PRIVACY_HEADER") }}
      </h1>
    </v-col>
    <v-col cols="12" class="privacyContent">
      <div v-html="$t('PRIVACY_TEXT')"></div>
    </v-col>
  </v-row>
</v-content>

